import { Flex } from '@chakra-ui/react'
import { useApp } from '@hb/react'
import { useMemo } from 'react'
import { useProfile } from '../../../../contexts/user/ProfileContext'
import { useConsentFormsStatus } from '../../../../hooks/consentForms/useConsentFormsStatus'
import { ConsentFormsStatusAdminView } from '../../../Templates'
import { DraftView } from '../Documents/DraftView'
// import { PatientConsentFormsStatusView } from './PatientConsentFormsStatus'

export const ProfileConsentForms = () => {
  const {
    user,
    userId,
    assessmentId,
    selectedAssessment: { populated },
  } = useProfile()
  const { appName } = useApp()
  const { drafts, practiceDrafts } = user ?? {}
  const draft = useMemo(
    () =>
      appName === 'providers-app'
        ? practiceDrafts?.consentFormTemplates
        : drafts?.consentFormTemplates,
    [appName, practiceDrafts, drafts],
  )
  const consentFormsStatus = useConsentFormsStatus(userId, user, populated)
  if (!userId) return null
  return (
    <Flex p={3} gap={2} w="100%" flexFlow="column">
      <DraftView templateKey="consentForm" draft={draft} name="Consent forms" />
      <ConsentFormsStatusAdminView
        consentFormsStatus={consentFormsStatus}
        patientId={userId}
        assessmentId={assessmentId}
      />
    </Flex>
  )
}
